import CautionPhraseListContainer from '../../containers/cautionPhraseList/cautionPhraseList';

export default function CautionPhraseList() {
  return (
    <CautionPhraseListContainer />
  );
}
